import { render, staticRenderFns } from "./connectQueue.vue?vue&type=template&id=de947ea0&scoped=true&"
import script from "./connectQueue.vue?vue&type=script&lang=js&"
export * from "./connectQueue.vue?vue&type=script&lang=js&"
import style0 from "./connectQueue.vue?vue&type=style&index=0&id=de947ea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de947ea0",
  null
  
)

export default component.exports